import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7200e69b"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  "class": "notouchie"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_5 = [_hoisted_2, _hoisted_3, _hoisted_4];
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_9 = [_hoisted_6, _hoisted_7, _hoisted_8];
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_13 = [_hoisted_10, _hoisted_11, _hoisted_12];
var _hoisted_14 = {
  key: 2,
  "class": "walkthrough__container"
};
var _hoisted_15 = {
  "class": "walkthrough__title"
};
var _hoisted_16 = {
  "class": "walkthrough__subtitle"
};
var _hoisted_17 = {
  "class": "walkthrough__content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", {
    "class": _normalizeClass({
      'walkthrough': true,
      'walkthrough-with-background': _ctx.$store.state.showWalkThrough,
      'heavy-overlay': _ctx.showHeavyOverlay
    })
  }, [_ctx.showTouchEventsLabel ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Voice and Touch Events Disabled During Walkthrough ")) : _createCommentVNode("", true), _ctx.showStopTutorial ? (_openBlock(), _createElementBlock("button", {
    key: 1,
    "class": "stopTutorial",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.stopTheTutorial();
    })
  }, "Stop Tutorial")) : _createCommentVNode("", true), _createElementVNode("div", {
    "class": "walkthrough__circle",
    style: _normalizeStyle({
      top: _ctx.circletop,
      left: _ctx.circleleft
    })
  }, _hoisted_5, 4), _createElementVNode("div", {
    "class": "walkthrough__circle",
    style: _normalizeStyle({
      bottom: _ctx.circle2bottom,
      right: _ctx.circle2right
    })
  }, _hoisted_9, 4), _createElementVNode("div", {
    "class": "walkthrough__circle",
    style: _normalizeStyle({
      bottom: _ctx.circle3bottom,
      left: _ctx.circle3left
    })
  }, _hoisted_13, 4), _ctx.$store.state.showWalkThrough && !_ctx.hideModal ? (_openBlock(), _createElementBlock("div", _hoisted_14, [!_ctx.showTouchEventsLabel ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 0,
    icon: "fa-times-circle",
    "class": "closebutton",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$store.commit('updateShowWalkthrough', false);
    })
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.title), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.subtitle), 1), _createElementVNode("div", _hoisted_17, [_createTextVNode(_toDisplayString(_ctx.content) + " ", 1), _ctx.$store.state.showSkipWalkthroughForever === true || _ctx.$store.state.showSkipWalkthroughForever === 'true' ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    "class": "skipButton",
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.skipForever && _ctx.skipForever.apply(_ctx, arguments);
    })
  }, "Don't show this again")) : _createCommentVNode("", true)]), _ctx.step > -1 ? (_openBlock(), _createElementBlock("button", {
    key: 1,
    "class": "walkthrough__button walkthrough__button--previous",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.showPreviousStep();
    })
  }, " Previous ")) : _createCommentVNode("", true), _ctx.showButton ? (_openBlock(), _createElementBlock("button", {
    key: 2,
    "class": "walkthrough__button",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      _ctx.showHeavyOverlay = false;
      _ctx.showNextStep();
      _ctx.showStopTutorial = true;
    })
  }, _toDisplayString(_ctx.buttonLabel), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 2);
}